export const PLUGIN_NAME = 'auth-fe';
export const COOKIE_KEY = 'blaze_auth';
export const GRAPH_QL_ERROR = 'GraphQL error: ';
//# sourceMappingURL=constants.js.map